// The words for eTIMS signing states (docs/plans/phase3-etims-vscu.md §4; ADR 0041). Every
// state is a word; the tag's shape and colour are secondary.
import type { EtimsFacilityMode } from '@wodi/shared';
import type { TagState } from '@wodi/ui';

export type FiscalState =
  'not_configured' | 'queued' | 'signed' | 'signed_offline' | 'failed' | 'transmission_failed';

export const FISCAL_STATE_LABELS: Record<FiscalState, { label: string; tag: TagState }> = {
  not_configured: { label: 'eTIMS is off', tag: 'neutral' },
  queued: { label: 'Waiting to be signed', tag: 'pending' },
  signed: { label: 'Signed', tag: 'done' },
  signed_offline: { label: 'Signed offline, waiting to send to KRA', tag: 'pending' },
  failed: { label: 'Signing failed', tag: 'failed' },
  transmission_failed: { label: 'KRA refused it', tag: 'failed' },
};

export const MODE_LABELS: Record<EtimsFacilityMode, { label: string; description: string }> = {
  off: {
    label: 'Off',
    description: 'Tax documents are not signed. Receipts say the tax invoice is not yet signed.',
  },
  oscu: {
    label: 'OSCU',
    description: 'Signed by KRA online, as each document is issued. Needs the internet.',
  },
  vscu: {
    label: 'VSCU',
    description:
      "Signed by the VSCU on this site, which keeps signing for a limited time when KRA can't be reached.",
  },
};

export const DOCUMENT_TYPE_LABELS = { invoice: 'Invoice', credit_note: 'Credit note' } as const;
